<div class="card" [class.inactive]="!isActive">
    <div class="card-title">
        <div class="title">
            <img *ngIf="icon && isActive" class="title-icon" [src]="icon" [alt]="title">
            <h3 placement="top" [ngbTooltip]="title" tooltipClass="ng-tooltip" class="text-truncate" [autoClose]="true"
                triggers="manual" #t="ngbTooltip" (click)="t.open()">
                {{title}}
            </h3>
        </div>

        <!-- 👇 Solo se muestra si showFavorite es true -->
        <button *ngIf="showFavorite" type="button" class="btn-favorite" (click)="setFavorite()">
            <fa-icon class="star-icon" [icon]="setIcon()"></fa-icon>
        </button>
    </div>
    <div class="card-content">
        <ng-content></ng-content>
    </div>
</div>